import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { LanguageService, defaultLanguages } from 'src/app/core/services/language.service';
import { Router } from '@angular/router';
import { IUser } from 'src/app/core/models/user.model';
import { sharedDataService } from 'src/app/core/services/sharedData.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { skipWhile, take } from 'rxjs/operators';
declare var HelpCrunch;

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css'],
})
export class NavigationComponent implements OnInit {
  userPremium = false;
  userSimple = false;
  user: IUser;
  profilePicture: any;
  language = 'en';
  showLanguages = false;

  notifications = [];
  notificationData;
  sub;

  constructor(
    private authService: AuthService,
    private languageService: LanguageService,
    public router: Router,
    private sharedData: sharedDataService,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.authService.LoggedinUser.subscribe((user) => {
      this.user = user;
    });
    this.languageService.Language.subscribe((lang) => {
      console.log('lang: ' + lang);
      if (lang) {
        this.language = lang;
        HelpCrunch('setPhraseList', lang);
      }
    });

    this.sub = this.notificationService.notifications$.pipe(
      skipWhile(value => value === null),
      ).subscribe(
      (notifications: any) => {
        console.log(notifications)
        this.notificationData = notifications;
        this.notifications = notifications?.results?.filter(notification => notification.notification.priority !== 'high') || [];

        if (this.notifications.length) {
          this.notifications = this.notifications.map(notification => {
            const { languageContents } = notification.notification;

            const lang = defaultLanguages.find(
              (lng) => lng.name === this.language
            );

            const defaultLanguage = 'english';
            let content = languageContents.find(content => content.language === lang.label) || languageContents.find(content => content.language === defaultLanguage);

            return {
              ...notification.notification,
              content
            }
          })
        }

        console.log(this.notifications)
      }
    );
  }

  currentNotification = null;
  openNotification(notification) {
    this.currentNotification = notification;
    console.log(notification)

    this.markNotificationAsSeen();
  }

  markNotificationAsSeen() {
    const body = {
      isSeen: true,
    };

    
    this.notificationService
      .updateUserNotification(
        this.user.id,
        this.currentNotification.id,
        body
        )
      .subscribe(
        (res) => {
          const data = {
            count: this.notificationData.count - 1,
            notSeen: this.notificationData.notSeen - 1,
            results: this.notificationData.results.filter(notification => notification.notificationId !== this.currentNotification.id)
          }
      
          this.notificationService.updateNotifications(data)

        },
        (err) => {}
      );
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
    this.notificationService.updateNotifications(null);
  }

  showNotifications = false;

  toggleNotifications() {
    this.showNotifications = !this.showNotifications;
  }

  useLanguage(language: string) {
    this.languageService.removeLanguage();
    localStorage.setItem('panelLang', JSON.stringify({ language }));
    this.languageService.setLanguage(language);
    window.location.reload();
    // this._translate.use(language);
  }

  logout() {
    this.sharedData.appId = null;
    this.authService.logout();
    localStorage.removeItem('panelLang');
    this.router.navigate(['/login']);
    HelpCrunch('hideChatWidget');
  }

  /**
   * Opens dropdown
   */
  openDropdown() {
    this.showLanguages = !this.showLanguages;
  }

  isVehicleActive(url): boolean {
    const queryParamsIndex = this.router.url.indexOf('?');
    const baseUrl =
      queryParamsIndex === -1
        ? this.router.url
        : this.router.url.slice(0, queryParamsIndex);
    return baseUrl === url;
  }

  canAccess(role: string[], type?: string[]): boolean {
    const currentUserRole = this.user.role.name;

    if (type) {
      const currentUserType = this.user.role.type;
      let isType = true;

      currentUserType
        ? (isType = !!(type.indexOf(currentUserType) !== -1))
        : null;

      return role.indexOf(currentUserRole) !== -1 && isType;
    } else {
      return role.indexOf(currentUserRole) !== -1;
    }
  }
}
